<div class="edit-container">
  <h1 class="solcitare-title">Editare permisiune</h1>
  <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
    <div class="edit-field">
      <mat-form-field appearance="fill">
        <mat-label>Nume</mat-label>
        <input type="text" matInput formControlName="name" />
        <mat-error
          *ngIf="!form.controls['name'].valid && form.controls['name'].touched"
        >
          Camp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>

    <div class="edit-field">
      <div class="spinner">
        <mat-spinner color="primary" *ngIf="isSectionsLoading"></mat-spinner>
      </div>
      <mat-form-field *ngIf="!isSectionsLoading" appearance="fill">
        <mat-label>Secțiuni</mat-label>
        <mat-select formControlName="section_id">
          <mat-option
            *ngFor="let section of sections$ | async"
            [value]="section.id"
          >
            {{ section.name }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            !form.controls['section_id'].valid &&
            form.controls['section_id'].touched
          "
        >
          Camp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>

    <div class="edit-field">
      <mat-form-field appearance="fill">
        <mat-label>Observații</mat-label>
        <input type="text" matInput formControlName="observations" />
        <mat-error
          *ngIf="
            !form.controls['observations'].valid &&
            form.controls['observations'].touched
          "
        >
          Camp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>

    <div class="spinner">
      <mat-spinner color="primary" *ngIf="isLoading"></mat-spinner>
    </div>
    <div class="edit-action-btns">
      <button
        class="buttons"
        mat-flat-button
        type="button"
        (click)="closeDialog()"
      >
        Close
      </button>
      <button
        class="buttons"
        mat-flat-button
        type="submit"
        color="primary"
        [disabled]="form.invalid"
      >
        Save
      </button>
    </div>
  </form>
</div>
